import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquispinner',
	templateUrl:'./JQUISpinnerPage.html',
	styles: [],
	styleUrls:['./JQUISpinnerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUISpinnerPage
{
	mdContent_225 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.spinner.JQUISpinner;
\`\`\``;
	mdContent_226 = `\`\`\`java
new JQUISpinner&lt;&gt;()
\`\`\``;
	mdContent_227 = `\`\`\`java
var spinner = new JQUISpinner<>();
spinner.getOptions().setMin(0);
spinner.getOptions().setMax(100);
spinner.getOptions().setStep(5);
\`\`\``;
}
